import React from "react";
import {
  FaWhatsapp,
  FaFacebookF,
  FaInstagram,
  FaYoutube,
  FaLinkedinIn,
  FaPhoneAlt,
} from "react-icons/fa";
import "./SocialBtn.css";

const SocialBtn = ({ phone = "9975708774" }) => {
  return (
    <div className="floating-social-wrapper">
      {/* WhatsApp */}
      <a
        href={`https://wa.me/${phone}`}
        target="_blank"
        rel="noopener noreferrer"
        className="floating-btn whatsapp"
        title="WhatsApp"
      >
        <FaWhatsapp />
      </a>

      {/* Call */}
      <a
        href={`tel:${phone}`}
        className="floating-btn call"
        title="Call Now"
      >
        <FaPhoneAlt />
      </a>

      {/* Facebook */}
      {/* <a
        href="https://www.facebook.com/orangeitech/"
        target="_blank"
        rel="noopener noreferrer"
        className="floating-btn facebook"
      >
        <FaFacebookF />
      </a> */}

      {/* Instagram */}
      {/* <a
        href="https://www.instagram.com/orangeitech/"
        target="_blank"
        rel="noopener noreferrer"
        className="floating-btn instagram"
      >
        <FaInstagram />
      </a> */}

      {/* YouTube */}
      {/* <a
        href="https://www.youtube.com/@Orangeitech"
        target="_blank"
        rel="noopener noreferrer"
        className="floating-btn youtube"
      >
        <FaYoutube />
      </a> */}

      {/* LinkedIn */}
      {/* <a
        href="https://www.linkedin.com/company/orange-itech-intstitue/?originalSubdomain=in"
        target="_blank"
        rel="noopener noreferrer"
        className="floating-btn linkedin"
      >
        <FaLinkedinIn />
      </a> */}
    </div>
  );
};

export default SocialBtn;

